<template>
  <div
    class='theme-location-dropdown__field-holder'
    :class="{
      'theme-input__field-holder--error': (!!errors.has(newName)),
      'theme-input__field-holder--is-disabled': disabled,
    }"
    data-vv-value-path='model'
    :data-vv-as='label'
  >
    <label class='theme-input__label' v-if='label'>
      {{ label }}
      <span v-if='isRequired' class='theme-input__label-asterisk'>*</span>
    </label>
    <div
      class='theme-location-dropdown'
      :class="{
        'theme-location-dropdown--green': green,
        'theme-location-dropdown--blue': blue,
        'theme-location-dropdown--focused': isFocused,
      }"
    >
      <div
        class='theme-location-dropdown__tag'
        v-for='item in model'
        :key='item.id'
        @click='toggleItem(item)'
      >
        <input type='hidden' :name='name' :value='item.id' :rules='rules'/>
        <input type='hidden' :name='`_labels[${name}]`' :value='item.name'/>
        <span class='location-name'>{{ item.name }}</span>
        <span class='icon-close location-close'></span>
      </div>
      <div class='theme-location-dropdown__wrap'>
        <input
          v-model='phrase'
          class='theme-input theme-location-dropdown__input'
          type='text'
          @keyup='suggest'
          @keydown='clearTimeout'
          @keydown.enter.prevent
          :disabled='disabled'
          @focus='isFocused = true'
          @blur='
            blur();
            isFocused = false;
          '
          :placeholder='placeholder'
        />
        <!-- @focus="showList = true" -->

        <span v-if="phrase" @click="clearPhrase" class="icon-clear theme-location-dropdown__icon-clear"></span>
        <span v-if='errors.has(newName)' class='icon-warning theme-input__icon theme-input__icon-error'></span>
      </div>

      <ul class='theme-location-dropdown__list' v-if='showList'>
          <li
            v-for='item in suggestions'
            class='theme-location-dropdown__item'
            :class="{ 'theme-location-dropdown__item--is-selected': item === selected }"
            :key='item.id'
            @click='pick(item)'
          >
            {{ resolve(item) }}
          </li>
        </ul>

    </div>
    <div class='theme-input__error-text' v-if='errors.has(newName)'>
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
  import _ from 'lodash';
  import field from '../admin/mixins/field';
  import $ from 'jquery';

  export default {
    props: {
      value: {
        default() {
          return [];
        },
      },
      resolve: {
        default: (hit) => {
          return hit.name;
        },
        type: Function,
      },
      endpoint: {
        default: '/admin/autocomplete/locations',
        type: String,
      },
      base: {
        default: '',
        type: String,
      },
      initial: {
        default: '',
        type: String,
      },
      isRequired: {
        default: false,
        type: Boolean,
      },
      green: {
        default: false,
        type: Boolean,
      },
      blue: {
        default: false,
        type: Boolean,
      },
      placeholder: {
        default: '',
        type: String,
      },
      data: {
        default: () => [],
        type: Array,
      },
    },
    data() {
      return {
        isDirtyData: null,
        showList: false,
        suggestions: [],
        selected: null,
        phrase: '',
        typingTimer: null,
        doneTypingInterval: 700,
        isFocused: false,
      };
    },
    methods: {
      suggest(event) {
        let keyCode = event.keyCode;

        switch (keyCode) {
          case 38:
            if (_.indexOf(this.suggestions, this.selected) === 0) {
              this.selected = this.suggestions[this.suggestions.length - 1];
            } else {
              this.selected = this.suggestions[
              _.indexOf(this.suggestions, this.selected) - 1
                ];
            }

            break;
          case 40:
            if (
              _.indexOf(this.suggestions, this.selected) ===
              this.suggestions.length - 1
            ) {
              this.selected = this.suggestions[0];
            } else {
              this.selected = this.suggestions[
              _.indexOf(this.suggestions, this.selected) + 1
                ];
            }

            break;
          case 13:
            this.pick(this.selected);

            break;
          case 9:
            break;
          default:
            this.typing();
            break;
        }
      },
      pick(item) {
        // this.phrase = this.resolve(item);
        this.phrase = '';
        this.showList = false;
        this.selected = null;
        this.isDirtyData = false;
        this.toggleItem(item);
      },
      toggleItem(item) {
        const index = this.model.findIndex((selected) => selected.id === item.id);
        if (index !== -1) {
          this.model.splice(index, 1);
        } else {
          this.model.push(item);
        }
      },
      typing() {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.doneTyping, this.doneTypingInterval);
        this.showList = true;
        this.isDirtyData = true;
      },
      clearTimeout() {
        clearTimeout(this.typingTimer);
      },
      doneTyping() {
        $.get(this.endpoint + '?q=' + this.phrase).then((response) => {
          this.suggestions = response;
        });
      },
      blur() {
        setTimeout(() => {
          this.showList = false;
          this.suggestions = [];
        }, 300);
      },
      clearPhrase() {
        this.phrase = '';
      }
    },
    mixins: [field],
    mounted() {
      if (this.data.length > 0) {
        this.model = this.data;
      }
    },
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/ThemeLocationDropdown.vue